/* Script for  */

// ====================
// CONSTANTS
// ====================

const SUCCESS = 0;
const ERR_KEY_COUNT = 1;
const ERR_DISPLAY_KEY_COUNT = 2;
const ERR_KEY_CREATE = 3;
const ERR_ENCRYPT_FILE = 4;
const ERR_FILE_DOWNLOAD = 5;
const ERR_WRONG_FILE_TYPE = 6;
const INSUFFICIENT_KEYS = 7;

const MODE_ENCRYPT = "enc";
const MODE_DECRYPT = "dec";

// ====================
// MISC. FUNCTIONS
// ====================

/**
 * If it exists, remove the current success/error message popup.
 */

function removeOutcomeMsg() {
  if (document.getElementById("outcomeMessageMsg")) {
    document.getElementById("outcomeMessageMsg")?.remove();
  }
}

/**
 * Disable/enable buttons and cursor while page is loading.
 * @param {bool} myBool - indicates whether disabling or enabling.
 */

function disableButtons(myBool: boolean) {
  // remove any leftover error messages on disable
  if (myBool) {
    removeOutcomeMsg();
  }

  // disable/enable buttons
  const buttons = document.querySelectorAll("button");
  buttons.forEach((b) => {
    b.disabled = myBool;
  });
  const inputs = document.querySelectorAll("input");
  inputs.forEach((b) => {
    b.disabled = myBool;
  });

  // set cursor loader
  if (myBool) {
    document.body.style.cursor = "wait";
  } else {
    document.body.style.cursor = "default";
  }
}

/**
 * Create and set success/error message popup.
 * @param {Object} button - button object
 * @param {int} outcome - integer from 0 to 6 indicating error type
 */

function outcomeMessage(button: HTMLElement, outcome: number) {
  let msg = "";
  let color = "rgb(41, 243, 115)";
  if (outcome == 0) {
    if (button.id == "uploadFormDec") {
      msg += "File decrypted successfully. Please check your downloads folder.";
      // show decrypted view button
      const element = document.getElementById("decViewContainer");
      if (element) {
        element.style.display = "block";
      };
    } else if (button.id == "uploadFormEnc") {
      msg += "File encrypted successfully. Please check your downloads folder.";
    } else if (button.id == "buttonCountId") {
      msg = "Key count updated!";
    } else if (button.id == "buttonCreateId") {
      msg = "Key added!";
    }
  } else {
    color = "red";
    // if (outcome == ERR_KEY_COUNT) {
    //   msg = "Failed key count.";
    // } else if (outcome == ERR_DISPLAY_KEY_COUNT) {
    //   msg = "Failed key count.";
    // } else 
    if (outcome == ERR_KEY_CREATE) {
      msg = "Failed to create key.";
    } else if (outcome == ERR_ENCRYPT_FILE) {
      msg = "Failed to encrypt/decrypt file.";
    } else if (outcome == ERR_FILE_DOWNLOAD) {
      msg = "Failed to encrypt/decrypt file.";
    } else if (outcome == ERR_WRONG_FILE_TYPE) {
      msg = "Please upload a .qkde file.";
    } else if (outcome == INSUFFICIENT_KEYS) {
      msg = "No keys available. Please add a key.";
    } else {
      msg = "Server error.";
    }
  }
  const res = document.createElement("p");
  res.textContent = msg;
  res.id = "outcomeMessageMsg";
  res.style.backgroundColor = color;
  button.after(res);
}

// ====================
// KEY COUNT FUNCTIONS
// ====================

/**
 * Retrieves key count and displays on page.
 * @returns {int} res - result of operation.
 */

async function displayKeyCount() {
  let res = SUCCESS;
  try {
    // fetch from backend
    const response = await fetch("/count");
    if (!response.ok) {
      disableButtons(false);
      res = ERR_KEY_COUNT;
    } else {
      const data = await response.json();
      const elementA = document.getElementById("keyCountA");
      if (elementA) elementA.textContent = data.countA;
      const elementB = document.getElementById("keyCountB");
      if (elementB) elementB.textContent = data.countB;
      disableButtons(false);
    }
  } catch (error) {
    console.log(`error: ${error}`);
    disableButtons(false);
    res = ERR_DISPLAY_KEY_COUNT;
  }
  return res;
}

/**
 * Checks whether there are enough keys in both HSMs to encrypt/decrypt a file.
 * @param {string} mode - either enc or dec
 * @returns bool
 */
function insufficientKeys(mode: string) {
  let qkde = "";
  if (mode == MODE_ENCRYPT) {
    qkde = "A";
  } else {
    qkde = "B";
  }
  // check enough keys
  const element = document.getElementById(`keyCount${qkde}`);
  if (element) {
    const keyCount = element.textContent;
    if (keyCount === '0') {
      return true;
    } else {
      return false;
    }
  }
}


// ====================
// NODE CONNECTION
// ====================

async function nodeConnections() {
  let res = SUCCESS;
  try {
    // fetch from backend
    const response = await fetch("/connection");
    if (response.ok) {
      const data = await response.json();
      const hostNodeElement = document.getElementById("hostNode");
      if (hostNodeElement) hostNodeElement.textContent = data.currentNode;
      const remoteNodeElement = document.getElementById("remoteNode");
      if (remoteNodeElement) remoteNodeElement.textContent = data.remoteNode;
      const encryptNodeElement = document.getElementById("encryptNode");
      if (encryptNodeElement) encryptNodeElement.textContent = data.currentNode;
      const decryptNodeElement = document.getElementById("decryptNode");
      if (decryptNodeElement) decryptNodeElement.textContent = data.remoteNode;
    }
  } catch (error) {
    console.log(`error: ${error}`);
  }
  return res;
}

// ====================
// ENCRYPT/DECRYPT FILE
// ====================

/**
 * Cleanup memory from decrypted file view. Removes link to file.
 */

function cleanup() {
  const blob = document.getElementById("decryptBlob");
  if (blob instanceof HTMLAnchorElement) {
    // remove active href link
    window.URL.revokeObjectURL(blob.href);
    document.body.removeChild(blob);
    // hide 'view decrypted file' button and file preview
    const decViewContainerElement = document.getElementById("decViewContainer");
    const decViewPreviewContainerElement = document.getElementById("decViewPreviewContainer");
    if (decViewContainerElement) decViewContainerElement.style.display = "none";
    if (decViewPreviewContainerElement) decViewPreviewContainerElement.style.display = "none";
  }
}

/**
 * After a file has been decrypted, create a file preview for it that displays
 * upon clicking a button.
 * @param {*} data - file to be previewed
 */

function viewDecryptedFile(data: File) {
  // add file preview for decrypted file and hide
  previewFileUpload(data, "decView");

  // create button with click event
  document?.getElementById("decViewButton")?.addEventListener("click", function (event) {
    event.preventDefault();
    const decView = document.getElementById("decViewPreviewContainer");
    if (decView && decView.style.display != "block") {
      decView.style.display = "block";
    } else if (decView) {
      decView.style.display == "none";
    }
  });
}

/**
 * Perform file encryption/decryption.
 * @param {string} mode - either 'enc' or 'dec'.
 * @returns {int} res - result of the operation.
 */

async function postFile(mode: string) {
  let res = SUCCESS;

  // create form for file upload
  const formData = new FormData();
  const fileElement = document.getElementById(`${mode}FileInput`) as HTMLInputElement | null
  let file;
  if (fileElement && fileElement.files) {
    file = fileElement.files[0];
  }
  else return;

  // error: trying to decrypt non-qkde file
  if (!file.name.match(/.*.qkde/) && mode == MODE_DECRYPT) {
    res = ERR_WRONG_FILE_TYPE;
  }

  if (res == SUCCESS) {
    // add file and mode to send to backend
    formData.append("myFile", file);
    formData.append("encOrDec", mode);

    // fetch request
    try {
      const response = await fetch("/encrypt", {
        method: "POST",
        body: formData,
      });
      if (!response.ok) {
        res = ERR_ENCRYPT_FILE;
      } else {
        // extract filename from header
        const contentHeader = response.headers.get("Content-Disposition");
        let filename = "downloaded-file";
        if (contentHeader) {
          const filenameMatch = contentHeader.match(/filename="(.+)"/);
          if (filenameMatch && filenameMatch[1]) {
            filename = filenameMatch[1];
          }
        }

        // create blob with file to download
        const data = await response.blob();
        const url = window.URL.createObjectURL(data);
        const a = document.createElement("a");
        a.id = "decryptBlob";
        a.style.display = "none";
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();

        // for decryption, create file view button with hidden file view
        if (mode == MODE_DECRYPT && res == SUCCESS) {
          viewDecryptedFile(data as File);
        } else {
          // cleanup
          cleanup();
        }
      }
    } catch (error) {
      console.error("Download failed:", error);
      res = ERR_FILE_DOWNLOAD;
    }
  }

  // update display
  if (res) {
    displayKeyCount();
    nodeConnections();
    return res;
  } else {
    await nodeConnections();
    return await displayKeyCount();
  }
}

// ======================
// FILE PREVIEW FUNCTIONS
// ======================

/**
 * Preview files as they are uploaded.
 * @param {file Object} file - file to be previewed.
 * @param {string} mode - either 'enc' or 'dec', or 'decView' for the post-decrypted file preview.
 */

function previewFileUpload(file: File, mode: string) {
  const previewContainer = document.getElementById(`${mode}PreviewContainer`);

  if (file && previewContainer) {
    // remove old file preview
    while (previewContainer.firstChild) {
      previewContainer.removeChild(previewContainer.firstChild);
    }

    // show file preview section
    if (mode != "decView") {
      previewContainer.style.display = "block";
    }

    // build file based on type
    if (file.type.startsWith("image/")) {
      previewImage(file, previewContainer);
    } else if (
      file.type.startsWith("text/") ||
      file.type.startsWith("application/json")
    ) {
      previewText(file, previewContainer);
    } else if (file.type.startsWith("application/pdf")) {
      previewPDF(file, previewContainer);
    } else {
      previewOther(file, previewContainer);
    }
  } else if (previewContainer) {
    // hide file preview
    previewContainer.style.display = "none";
  }
}

// build image file preview
function previewImage(file: File, previewContainer: HTMLElement) {
  const reader = new FileReader();
  reader.onload = (e) => {
    const img = document.createElement("img");
    const result = e.target?.result;
    if (typeof result === "string") {
      img.src = result;
    }
    img.style.maxWidth = "200px";
    img.style.maxHeight = "200px";
    previewContainer.appendChild(img);
  };
  reader.readAsDataURL(file);
}

// build text and json file preview
function previewText(file: File, previewContainer: HTMLElement) {
  const MAX_TEXT_SIZE = 300; // BYTES

  if (file.size > MAX_TEXT_SIZE) {
    // truncate file as too long
    const reader = new FileReader();
    reader.onload = (e) => {
      const pre = document.createElement("pre");
      pre.style.whiteSpace = "pre-wrap";
      pre.classList.add("filePreview");
      if (e.target)
        pre.textContent = e.target.result + "\n\n[Preview truncated...]";
      previewContainer.appendChild(pre);
    };
    reader.readAsText(file.slice(0, MAX_TEXT_SIZE));
  } else {
    // show full file
    const reader = new FileReader();
    reader.onload = (e) => {
      const pre = document.createElement("pre");
      pre.style.whiteSpace = "pre-wrap";
      pre.classList.add("filePreview");
      const result = e.target?.result;
      if (typeof result === 'string')
        pre.textContent = result;
      if (file.size == 0) {
        pre.textContent += "[This file is empty.]";
      }
      previewContainer.appendChild(pre);
    };
    reader.readAsText(file);
  }
}

// build pdf file preview
function previewPDF(file: Blob | MediaSource, previewContainer: HTMLElement) {
  const objectURL = URL.createObjectURL(file);
  const iframe = document.createElement("iframe");
  iframe.src = objectURL;
  iframe.width = "100%";
  iframe.height = "400px";
  previewContainer.appendChild(iframe);

  // Clean up the object URL when done
  previewContainer.dataset.objectUrl = objectURL;
  window.addEventListener("pagehide", () => URL.revokeObjectURL(objectURL));
}

// details for unsupported file preview
function previewOther(file: File, previewContainer: HTMLElement) {
  const info = document.createElement("div");

  // handle .qkde files
  let fileType = file.type;
  if (file.name && file.name.match(/.*.qkde/)) {
    fileType = "QKDLite Encrypted File";
  } else if (!file.type) {
    fileType = "Unknown";
  }

  // add information for qkde and unknown file types
  info.innerHTML = `
        <div class="filePreview">
            <p><strong>File name:</strong> ${file.name}</p>
            <p><strong>File type:</strong> ${fileType}</p>
            <p><strong>Size:</strong> ${(file.size / 1024).toFixed(2)} KB</p>
            <p><strong>Last modified:</strong> ${new Date(
    file.lastModified
  ).toLocaleString()}</p>
            <p class="note">Preview not available for this file type.</p>
        </div>
    `;
  previewContainer.appendChild(info);
}

// ==========
// ACCORDION
// ==========

function accordion(button: HTMLElement, id: string) {
  const a = document.getElementById(id);

  if (a?.style.maxHeight) {
    a.style.maxHeight = "";
  } else if (a && a.scrollHeight) {
    const scrollHeight = a.scrollHeight;
    a.style.maxHeight = scrollHeight * 1.2 + "px";
  }
  button.classList.toggle("active");
}

// ========
// EVENTS
// ========

// Loads key count on startup
window.onload = function () {
  // add connection
  displayKeyCount();
  nodeConnections();
};

// Utility to get element safely
function getElement<T extends HTMLElement>(id: string): T {
  const el = document.getElementById(id);
  if (!el) throw new Error(`Element with id ${id} not found`);
  return el as T;
}

// Button count
getElement<HTMLButtonElement>("buttonCountId").addEventListener(
  "click",
  async function (event) {
    event.preventDefault();
    disableButtons(true);
    const res = await displayKeyCount();
    outcomeMessage(this, res);
  }
);

// Create key
getElement<HTMLButtonElement>("buttonCreateId").addEventListener(
  "click",
  async function (event) {
    event.preventDefault();
    disableButtons(true);
    let res = SUCCESS;

    const response = await fetch("/create");
    if (!response.ok) {
      res = ERR_KEY_CREATE;
    }

    // update key count
    if (res) {
      displayKeyCount();
    } else {
      res = await displayKeyCount();
    }
    outcomeMessage(this, res);
  }
);

// File inputs
getElement<HTMLInputElement>("encFileInput").addEventListener(
  "change",
  function (event) {
    removeOutcomeMsg();
    const input = event.target as HTMLInputElement;
    if (input.files?.[0]) {
      previewFileUpload(input.files[0], MODE_ENCRYPT);
    }
  }
);

getElement<HTMLInputElement>("decFileInput").addEventListener(
  "change",
  function (event) {
    removeOutcomeMsg();
    cleanup();
    const input = event.target as HTMLInputElement;
    if (input.files?.[0]) {
      previewFileUpload(input.files[0], MODE_DECRYPT);
    }
  }
);

// Forms
getElement<HTMLFormElement>("uploadFormEnc").addEventListener(
  "submit",
  async function (event) {
    event.preventDefault();
    disableButtons(true);
    if (insufficientKeys(MODE_ENCRYPT)) {
      outcomeMessage(this, INSUFFICIENT_KEYS);
      disableButtons(false);
    } else {
      const res = await postFile(MODE_ENCRYPT);
      outcomeMessage(this, res!);
    }
  }
);

getElement<HTMLFormElement>("uploadFormDec").addEventListener(
  "submit",
  async function (event) {
    event.preventDefault();
    disableButtons(true);
    if (insufficientKeys(MODE_DECRYPT)) {
      outcomeMessage(this, INSUFFICIENT_KEYS);
      disableButtons(false);
    } else {
      const res = await postFile(MODE_DECRYPT);
      outcomeMessage(this, res!);
    }
  }
);

// Accordion buttons
["collapseButton1", "collapseButton2", "collapseButton3"].forEach(
  (id, index) => {
    getElement<HTMLButtonElement>(id).addEventListener("click", function (event) {
      event.preventDefault();
      accordion(this, `collapsible${index + 1}`);
    });
  }
);
